const STORAGE_KEY = 'gladly-theme';
const DEFAULT_THEME = 'light';

export function getTheme() {
  try {
    return localStorage.getItem(STORAGE_KEY) || DEFAULT_THEME;
  } catch (e) {
    return DEFAULT_THEME;
  }
}

export function setTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch (e) {
    // localStorage may be unavailable
  }
  try {
    document.documentElement.setAttribute('data-theme', theme);
  } catch (e) {
    // document may be unavailable in test environments
  }
}

export function initTheme() {
  const theme = getTheme();
  try {
    document.documentElement.setAttribute('data-theme', theme);
  } catch (e) {
    // document may be unavailable in test environments
  }
}
